<div class="flex">
  <div class="login-content">
    <div class="login-container">
      <h2 class="login-title">InnovaTransit</h2>
      <p class="login-subtitle">Alterar Senha</p>
      <form class="login-form" [formGroup]="alteraSenhaForm" (ngSubmit)="alterarSenha()">
        <div class="password-wrapper">
          <ion-item class="password-item">
            <ion-input [type]="showNewPassword ? 'text' : 'password'" label="Nova Senha" labelPlacement="floating"
              placeholder="Nova Senha" formControlName="senha">
            </ion-input>
          </ion-item>
          <div class="eye-icon" (click)="toggleNewPassword()">
            <img [src]="showNewPassword ? 'assets/icon/olho-aberto.png' : 'assets/icon/olho.png'"
              alt="Mostrar ou ocultar senha" />
          </div>
        </div>

        <!-- Campo Confirme a Senha -->
        <div class="password-wrapper">
          <ion-item class="password-item">
            <ion-input [type]="showConfirmPassword ? 'text' : 'password'" label="Confirme a Senha"
              labelPlacement="floating" placeholder="Confirme a Senha" formControlName="confirmaSenha">
            </ion-input>
          </ion-item>
          <div class="eye-icon" (click)="toggleConfirmPassword()">
            <img [src]="showConfirmPassword ? 'assets/icon/olho-aberto.png' : 'assets/icon/olho.png'"
              alt="Mostrar ou ocultar senha" />
          </div>
        </div>

          <ion-button expand="full" type="submit" class="login-button" [disabled]="loading || !alteraSenhaForm.valid">
            <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
            <span *ngIf="!loading">Confirmar</span>
          </ion-button>

      </form>
    </div>
  </div>
</div>